import React from "react";
import HeaderDrawer from "../../../common/components/HeaderDrawer";
import RegisterBi from "../../components/RegisterBi";

const RegisterBiScreen = (props) => {
  return (
    <HeaderDrawer name="Cadastrar nova Tela">
      <RegisterBi
        onRequestSend={(values, date, hour) =>
          props.registerBi(values, date, hour)
        }
        {...props}
      />
    </HeaderDrawer>
  );
};

export default RegisterBiScreen;
